<template>
  <div class="nav">
    <div class="nav-top">
      <div class="center" v-if="menuBar && menuBar.length > 0">
        <ul>
          <li>
            <a href="/about">{{ menuBar[0].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[0].children" :key="subs.code">
                <a :href="'/about/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
          <li>
            <a href="/news">{{ menuBar[1].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[1].children" :key="subs.code">
                <a :href="'/news/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
          <li>
            <a href="/brand">{{ menuBar[2].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[2].children" :key="subs.code">
                <a :href="'/brand/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
        </ul>

        <div class="logo">
          <a href="/">
            <img
              src="@s/data/uploads/20180718/c996e8729f20e8374dc9ad52221bf2b8.png"
            />
            <p v-if="!$store.state.en">心相近 乐无垠</p>
          </a>
        </div>

        <ul style="float: right; margin: 0px 10px 0px 0px">
          <li>
            <a href="/ecological">{{ menuBar[3].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[3].children" :key="subs.code">
                <a :href="'/ecological/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
          <li>
            <a href="/training">{{ menuBar[4].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[4].children" :key="subs.code">
                <a :href="'/training/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
         <li>
            <a href="/coo">{{ menuBar[5].module }}</a>
            <div>
              <p v-for="(subs,i) in menuBar[5].children" :key="subs.code">
                <a :href="'/coo/' + (i==0?'':i)">{{subs.module}}</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="nav-footer"
      style="width: 100%; height: 0.6rem; border-top: 1px solid #000"
    >
      <div
        class="center"
        style="height: 0.6rem; border-top: 1px solid #ffffff; margin-top: -1px"
      ></div>
    </div>

    <div
      class="chinese_english"
      style="width: 25%; position: absolute; top: 10px; right: 5%"
    >
      <div class="sousuo_input" style="display: block">
          <input
            class="input1"
            type="text"
            autocomplete="off"
            v-model="keyword"
            @keyup.enter="goSearch"
            maxlength="23"
            placeholder="全站搜索"
          />
          <button class="sousuo" id="sousuo" @click="goSearch"></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      menuBar: this.$store.state.menuBar,
      keyword: this.$route.query.keyword || ''
    };
  },
  watch:{
    '$store.state.menuBar'(val){
        this.menuBar = val
        this.$nextTick(()=>{
           $(".nav-top").hover(
            function () {
              $(".nav-top").css("background", "#26499d");
              $(".nav-footer").css("background", "transparent");
            },
            function () {
              $(".nav-top").css("background", "transparent");
              $(".nav-footer").css("background", "transparent");
            }
          );

          $(".nav ul li").hover(
            function () {
              $(".nav").css("background", "#26499d");
            },
            function () {
              $(".nav").css("background", "transparent");
              $(".nav-footer").css("background", "transparent");
            }
          );
        })
    }
  },
  methods: {
    goSearch () {
      location.href="/search?keyword="+this.keyword
    }
  },
  mounted() {
    if(this.menuBar){
      $(".nav-top").hover(
          function () {
            $(".nav-top").css("background", "#26499d");
            $(".nav-footer").css("background", "transparent");
          },
          function () {
            $(".nav-top").css("background", "transparent");
            $(".nav-footer").css("background", "transparent");
          }
        );

        $(".nav ul li").hover(
          function () {
            $(".nav").css("background", "#26499d");
          },
          function () {
            $(".nav").css("background", "transparent");
            $(".nav-footer").css("background", "transparent");
          }
        );
    }
  },
};
</script>
<style>
@import '~@/static/skin/web/css/gong.css';
.nav.en ul li div {
  margin-top: 0.4rem;
  margin-bottom: 0.2rem;
}
.nav.en ul li div {
  width: fit-content;
  left: 0;
}
.nav.en ul li div p {
  width: 100%;
  line-height: 0.24rem;
  margin-left: 0;
}
</style>
